import { http } from 'services/http';
import { TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys';
import type { TCreateTripTaskReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateTripTask = (tripId: number) => {
  return useMutationBase<unknown, unknown, TCreateTripTaskReq>({
    mutationFn: async (variables) => {
      await http.post<unknown>(`/v1/trips/${tripId}/trip-tasks`, variables);
    },
    invalidateCallback: () => [
      [TRIP_TASKS_GET_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
